module.exports = __webpack_public_path__ + "img/donquicompte-thumbnail1.60d9731a.png";